import { render } from "./Diagnostico_PlanDiag.vue?vue&type=template&id=af7077fa"
import script from "./Diagnostico_PlanDiag.vue?vue&type=script&lang=js"
export * from "./Diagnostico_PlanDiag.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__